export default __webpack_public_path__ + "static/media/02_photo.da0b18ea.jpg";